export default __webpack_public_path__ + "static/media/settings.2d6f7344.svg";